import Button from "@atomaro/ui-kit/components/Button/Button/Button";
import Modal from "@atomaro/ui-kit/components/Modal/Modal";
import { useCurrentHiveStore } from "entities/currentHive";
import { CreateApiaryModalBody, CreateApiaryModalFooter, CreateApiaryModalHead } from "features/apiary/CreateApiary/styles";
import { PhotosEditActionsWrapper, PhotosEditBody, PhotosEditItem } from "features/hive/ui/PhotosEdit/styles.ts";
import {
    NewHiveHead,
    NewHiveTitle,
    NewHiveWrapper,
} from "features/hives/ui/hivesNew/styles";
import { FC, useState } from "react";
import { downloadAttachment, getAttachmentUrl } from "shared/api/attachments";
import { toRem } from "shared/helpers";
import { Drawer } from "shared/ui/drawer";
import { CloseIcon } from "shared/ui/icons";
import DownloadIcon from "shared/ui/icons/downloadIcon.tsx";
import TrashIcon from "shared/ui/icons/trashIcon.tsx";
import { Spacer } from "shared/ui/spacer";

type Props = {
    isOpen: boolean;
    onClose: () => void;
    isMobile?: boolean;
};

const PhotoEditActions: FC<{ onDownload: () => void; onDelete: () => void }> = ({ onDownload, onDelete }) => (
    <PhotosEditActionsWrapper className={"photo-actions"}>
        <div onClick={onDownload}>
            <DownloadIcon />
        </div>
        <div onClick={onDelete}>
            <TrashIcon />
        </div>
    </PhotosEditActionsWrapper>
);

export const PhotosEdit: FC<Props> = ({ isOpen, onClose, isMobile }) => {
    const currentHive = useCurrentHiveStore((s) => s.currentHive);
    const updateHive = useCurrentHiveStore((s) => s.updateHive);

    const [deleteId, setDeleteId] = useState<string | null>(null);
    const [isDeleteOpen, setIsDeleteOpen] = useState(false);

    const items = currentHive?.attachments || [];

    const openDeleteModal = (id: string) => {
        setDeleteId(id);
        setIsDeleteOpen(true);
    };

    const confirmDelete = async () => {
        if (!deleteId || !currentHive) return;

        const next = currentHive.attachments
            .map((el) => el.id)
            .filter((id) => id !== deleteId);

        // @ts-expect-error backend expects only ids
        await updateHive({ attachments: next });

        setIsDeleteOpen(false);
        setDeleteId(null);
    };

    return (
        <Drawer isOpen={isOpen} position={isMobile ? "bottom" : "right"} onClose={onClose}>
            <NewHiveWrapper>
                <NewHiveHead $isMobile={isMobile}>
                    <Button
                        iconPrefix={<CloseIcon />}
                        variant={isMobile ? "ghost" : "secondary"}
                        colorScheme="neutral"
                        style={{ alignSelf: "flex-end", width: isMobile ? toRem(24) : toRem(36) }}
                        size={isMobile ? "s" : "m"}
                        onClick={onClose}
                    />
                    <NewHiveTitle>Фото улья</NewHiveTitle>
                    {isMobile && <Spacer width={toRem(24)} height={toRem(24)} />}
                </NewHiveHead>

                <PhotosEditBody>
                    {items.map((item: { id: string }) => (
                        <PhotosEditItem key={item.id}>
                            <img src={getAttachmentUrl(item.id)} />
                            <p></p>
                            <PhotoEditActions
                                onDownload={() => downloadAttachment(item.id)}
                                onDelete={() => openDeleteModal(item.id)}
                            />
                        </PhotosEditItem>
                    ))}
                </PhotosEditBody>

                <Modal
                    isOpen={isDeleteOpen}
                    centered
                    style={{ padding: 0, maxHeight: "100%" }}
                    onClickOverlay={() => setIsDeleteOpen(false)}
                >
                    <CreateApiaryModalHead>
                        Удалить фото улья
                        <Button
                            iconPrefix={<CloseIcon />}
                            variant="ghost"
                            colorScheme="neutral"
                            style={{ width: toRem(24) }}
                            size={isMobile ? "s" : "m"}
                            onClick={() => setIsDeleteOpen(false)}
                        />
                    </CreateApiaryModalHead>

                    <CreateApiaryModalBody>
                        Это действие нельзя отменить. Удалить фото?
                    </CreateApiaryModalBody>

                    <CreateApiaryModalFooter>
                        <Button
                            label="Отмена"
                            variant="secondary"
                            colorScheme="neutral"
                            size="l"
                            onClick={() => setIsDeleteOpen(false)}
                        />
                        <Button
                            label="Удалить"
                            size="l"
                            onClick={confirmDelete}
                        />
                    </CreateApiaryModalFooter>
                </Modal>
            </NewHiveWrapper>
        </Drawer>
    );
};

